/**
 * Utility functions for application configuration
 * Centralizes environment-specific settings and URL handling
 */

/**
 * Check if image cache busting is enabled
 * @returns {boolean} True if cache busting should be applied to image URLs
 */
export const isImageCacheBustingEnabled = () => {
  // Disable image cache busting for better performance
  // Cache busting should only be used for new items via smart cache-busting
  return false;
};

/**
 * Get the backend API base URL
 * This function determines the appropriate backend URL based on:
 * 1. Environment variables (REACT_APP_API_URL)
 * 2. Current hostname and port
 * 3. Development vs production environment
 * 4. Stored IP for cross-device access
 * 
 * @returns {string} The base URL for backend API requests
 */
export const getBackendBaseUrl = () => {
  // Always use direct backend URL (no proxy needed)
  const defaultUrl = window.location.hostname === 'localhost' 
    ? 'http://localhost:8000' 
    : 'https://clutterlogix-852e5ea54060.herokuapp.com';
  
  // Use existing REACT_APP_API_BASE_URL or REACT_APP_API_URL, fallback to defaultUrl
  const backendUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || defaultUrl;
  
  console.log(`[getBackendBaseUrl] Using backend: ${backendUrl}`);
  
  // Clear any old cached URLs that might be wrong
  const cachedUrl = sessionStorage.getItem('backend_base_url');
  if (cachedUrl && cachedUrl !== backendUrl) {
    console.log(`[getBackendBaseUrl] Clearing old cached URL: ${cachedUrl}`);
    sessionStorage.removeItem('backend_base_url');
  }
  
  // Store for consistency
  sessionStorage.setItem('backend_base_url', backendUrl);
  
  return backendUrl;
};